import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    selectAvailableLanguages,
    selectPreferredLanguage,
    setPreferredLanguage
} from 'tradera-state/language';
import RadioGroup from 'tradera-components/form-controls/radio-group';
import { useTranslator, useUrlLocalizer } from 'tradera-lang';
import { MopinionLanguageFeedbackButton } from 'components/customer-feedback/mopinion-button';
import LanguageIcon from '@tradera/blueprint/theme/icons2/language.svg?jsx';

export const LanguageSelect = ({
    idPrefix,
    languages,
    preferredLanguage,
    setPreferredLanguage,
    onLanguageSelected
}) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    onLanguageSelected = onLanguageSelected || (() => {});
    const onLanguageChanged = (code, e) => {
        setPreferredLanguage(code, toLocalizedUrl);
        onLanguageSelected(code, e);
    };
    return (
        <div className="p-4">
            <div className="d-flex align-items-center">
                <LanguageIcon className="icon icon-md" />
                <strong className="ml-4">{t('siteHeader_language')}</strong>
                <span className="badge badge-sm badge-danger ml-auto mr-2">
                    Beta
                </span>
            </div>
            <div className="alert alert-info d-flex my-2 text-hyphenate">
                <span>
                    {t('siteHeader_languageDisclaimerShort')}
                    <MopinionLanguageFeedbackButton
                        text={t('siteHeader_languageLeaveFeedBack')}
                        className="btn btn-link p-0 d-block"
                    />
                </span>
            </div>
            <RadioGroup
                id={`${idPrefix}-language-group`}
                options={languages.map(language => ({
                    name: `${language.displayName} - ${language.languageCodeIso3}`,
                    value: language.languageCodeIso2
                }))}
                checked={preferredLanguage.languageCodeIso2}
                handleOnChange={onLanguageChanged}
                className="form-check-sm mt-3 ml-3"
                radioButtonClassName="form-check-sm"
            />
        </div>
    );
};

LanguageSelect.propTypes = {
    idPrefix: PropTypes.string.isRequired,
    languages: PropTypes.arrayOf(
        PropTypes.shape({
            languageCodeIso2: PropTypes.string,
            displayName: PropTypes.string,
            languageCodeIso3: PropTypes.string
        })
    ),
    preferredLanguage: PropTypes.object,
    onLanguageSelected: PropTypes.func
};

const mapStateToProps = state => ({
    languages: selectAvailableLanguages(state),
    preferredLanguage: selectPreferredLanguage(state)
});

const mapDispatchToProps = {
    setPreferredLanguage
};

export const ConnectedLanguageSelect = connect(
    mapStateToProps,
    mapDispatchToProps
)(LanguageSelect);
